export default __webpack_public_path__ + "static/media/people6small.5f816d03.jpg";